import type {
  MediaConditions,
  MediaQueryType,
} from '@/app/components/media/image/types';

export const DEFAULT_IMAGE =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

export const WIDTH_DESCRIPTORS = [
  128, 256, 384, 512, 640, 768, 896, 1024, 1280, 1408, 1664, 1920, 2048, 2304,
  2560,
];

// Media query for "Device size" constants
export const MEDIA_QUERY_DEVICE_SIZE: Record<MediaQueryType, number> = {
  desktop_xl: 1920,
  desktop_lg: 1600,
  desktop_md: 1440,
  desktop_sm: 1280,
  tablet_lg: 1024,
  tablet_md: 768,
  tablet_sm: 640,
  mobile_lg: 576,
  mobile_md: 480,
  mobile_sm: 390,
  mobile_xs: 320,
};

// Media query for  "<source> image width" constants
export const MEDIA_QUERY_SOURCE_IMAGE_WIDTH: Record<MediaQueryType, number> = {
  desktop_xl: 1920,
  desktop_lg: 1600,
  desktop_md: 1440,
  desktop_sm: 1280,
  tablet_lg: 960,
  tablet_md: 750,
  tablet_sm: 640,
  mobile_lg: 576,
  mobile_md: 414,
  mobile_sm: 375,
  mobile_xs: 320,
};

// Media queries for device sizes
export const MEDIA_QUERY_SOURCE: Record<MediaQueryType, MediaConditions> = {
  // minWidth: 1920
  desktop_xl: {
    minWidth: MEDIA_QUERY_DEVICE_SIZE.desktop_xl,
    device: 'desktop',
  },
  // minWidth: 1600, maxWidth: 1919
  desktop_lg: {
    minWidth: MEDIA_QUERY_DEVICE_SIZE.desktop_lg,
    maxWidth: MEDIA_QUERY_DEVICE_SIZE.desktop_xl - 1,
    device: 'desktop',
  },
  // minWidth: 1440, maxWidth: 1599
  desktop_md: {
    minWidth: MEDIA_QUERY_DEVICE_SIZE.desktop_md,
    maxWidth: MEDIA_QUERY_DEVICE_SIZE.desktop_lg - 1,
    device: 'desktop',
  },
  // minWidth: 1280, maxWidth: 1439
  desktop_sm: {
    minWidth: MEDIA_QUERY_DEVICE_SIZE.desktop_sm,
    maxWidth: MEDIA_QUERY_DEVICE_SIZE.desktop_md - 1,
    device: 'desktop',
  },
  // minWidth: 1024, maxWidth: 1279
  tablet_lg: {
    minWidth: MEDIA_QUERY_DEVICE_SIZE.tablet_lg,
    maxWidth: MEDIA_QUERY_DEVICE_SIZE.desktop_sm - 1,
    device: 'mobile',
  },
  // minWidth: 768, maxWidth: 1023
  tablet_md: {
    minWidth: MEDIA_QUERY_DEVICE_SIZE.tablet_md,
    maxWidth: MEDIA_QUERY_DEVICE_SIZE.tablet_lg - 1,
    device: 'mobile',
  },
  // minWidth: 576, maxWidth: 767
  tablet_sm: {
    minWidth: MEDIA_QUERY_DEVICE_SIZE.mobile_lg,
    maxWidth: MEDIA_QUERY_DEVICE_SIZE.tablet_md - 1,
    device: 'mobile',
  },
  // minWidth: 480, maxWidth: 575
  mobile_lg: {
    minWidth: MEDIA_QUERY_DEVICE_SIZE.mobile_md,
    maxWidth: MEDIA_QUERY_DEVICE_SIZE.mobile_lg - 1,
    device: 'mobile',
  },
  // minWidth: 390, maxWidth: 479
  mobile_md: {
    minWidth: MEDIA_QUERY_DEVICE_SIZE.mobile_sm,
    maxWidth: MEDIA_QUERY_DEVICE_SIZE.mobile_md - 1,
    device: 'mobile',
  },
  // minWidth: 321, maxWidth: 389
  mobile_sm: {
    minWidth: MEDIA_QUERY_DEVICE_SIZE.mobile_xs + 1,
    maxWidth: MEDIA_QUERY_DEVICE_SIZE.mobile_sm - 1,
    device: 'mobile',
  },
  // maxWidth: 320
  mobile_xs: {
    maxWidth: MEDIA_QUERY_DEVICE_SIZE.mobile_xs,
    device: 'mobile',
  },
};
